if (!customElements.get('chronoera-hero-motion')) {
  customElements.define('chronoera-hero-motion', class extends HTMLElement {
    connectedCallback() {
      if (this.abort || !this.querySelector('template')) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.preference = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.connection = navigator.connection;
      this.ready = false;
      this.playbackBlocked = false;
      this.inView = false;
      this.preference.addEventListener('change', () => this.sync(), options);
      this.connection?.addEventListener('change', () => this.sync(), options);
      document.addEventListener('visibilitychange', () => this.sync(), options);
      this.observer = new IntersectionObserver(([entry]) => {
        this.inView = entry.isIntersecting;
        this.sync();
      }, { threshold: 0.12 });
      this.observer.observe(this);
      const signal = this.abort.signal;
      const prepare = async () => {
        const image = this.querySelector('img');
        if (image?.decode) await image.decode().catch(() => {});
        if (signal.aborted) return;
        const ready = () => {
          if (signal.aborted) return;
          this.ready = true;
          this.sync();
        };
        if ('requestIdleCallback' in window) {
          this.idle = window.requestIdleCallback(ready, { timeout: 2000 });
        } else {
          this.timer = window.setTimeout(ready, 250);
        }
      };
      if (document.readyState === 'complete') prepare();
      else window.addEventListener('load', prepare, { ...options, once: true });
    }
    setupVideo() {
      if (this.video) return;
      const fragment = this.querySelector('template').content.cloneNode(true);
      fragment.querySelector('video')?.removeAttribute('poster');
      this.append(fragment);
      this.video = this.querySelector('video');
      if (!this.video) return;
      this.video.muted = true;
      this.video.loop = true;
      this.video.playsInline = true;
      const options = { signal: this.abort.signal };
      this.video.addEventListener('playing', () => {
        this.classList.add('has-motion');
      }, options);
      this.video.addEventListener('error', () => {
        this.classList.remove('has-motion');
      }, options);
    }
    sync() {
      if (this.preference.matches || this.connection?.saveData || ['slow-2g', '2g'].includes(this.connection?.effectiveType)) {
        this.video?.pause();
        this.classList.remove('has-motion');
        return;
      }
      if (!this.ready || !this.inView || document.hidden || this.playbackBlocked) {
        this.video?.pause();
        return;
      }
      this.setupVideo();
      this.video?.play().catch(() => {
        this.classList.remove('has-motion');
        this.playbackBlocked = true;
      });
    }
    disconnectedCallback() {
      this.video?.pause();
      this.observer?.disconnect();
      this.abort?.abort();
      if (this.idle !== undefined) window.cancelIdleCallback?.(this.idle);
      window.clearTimeout(this.timer);
      this.ready = false;
      this.abort = null;
      this.video?.remove();
      this.video = null;
      this.classList.remove('has-motion');
    }
  });
}


